import api from "./Api";

class VendedorService {
  GetVendedor(payload) {
    return api.get("/v1/vendedor/" + payload).then((response) => {
      return response.data;
    });
  }

  PostVendedor(payload) {
    return api.post("/v1/vendedor/", payload).then((response) => {
      return response.data;
    });
  }

  PutVendedor(payload) {
    return api.put("/v1/vendedor/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteVendedor(payload) {
    return api.delete("/v1/vendedor/" + payload).then((response) => {
      return response.data;
    });
  }

  GetVendedorOData(payload) {
    return api.get("/OData/Vendedor" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new VendedorService();
